import { render } from "./InstructorHorses.vue?vue&type=template&id=20006a8a"
import script from "./InstructorHorses.vue?vue&type=script&lang=js"
export * from "./InstructorHorses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__